/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const moon_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.842 3.406a9.855 9.855 0 0 1 1.67 4.852c.223 3.751-1.618 7.306-4.74 9.153-.954.568-2 .945-3.086 1.11-.584.1-1.046.572-1.16 1.18a1.514 1.514 0 0 0 .651 1.551c3.557 2.38 8.121 2.326 11.625-.14 3.503-2.465 5.28-6.873 4.527-11.225-.754-4.353-3.896-7.824-8.003-8.84a1.395 1.395 0 0 0-1.544.625 1.554 1.554 0 0 0 .06 1.734Z"
      clipRule="evenodd"
    />
  </svg>
)
export default moon_medium
